import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from "@angular/core";
import { Channel } from "../../../domain/channel";
import { ChannelRepository } from "../../../domain/channel-repository";
import { Logger } from "../../../infrastructure/logger";

@Component({
  selector: "icn-code-popup",
  templateUrl: "code-popup.html",
  styleUrls: ["code-popup.scss"],
})
export class CodePopupComponent {
  constructor(
    private channelRepository: ChannelRepository,
    private logger: Logger,
    private changeDetectorRef: ChangeDetectorRef,
  ) {}

  @Input()
  channel: Channel;

  @Output()
  closeButtonClicked = new EventEmitter();

  expiryDays = 1;

  url = "";

  closeIcon = "/assets/icons/x-close-pop.svg";

  onCloseButtonClicked(event) {
    event.stopImmediatePropagation();
    this.closeButtonClicked.emit();
  }

  createUrl() {
    this.channelRepository
      .getChannelCode(this.channel.id, this.expiryDays)
      .then((code) => {
        this.url = window.location.origin + "/preview/" + code;
        this.changeDetectorRef.markForCheck();
      })
      .catch((err) => {
        this.logger.warn("Could not get preview code: " + err);
      });
  }

  goToUrl() {
    window.open(this.url, "_blank");
  }
}
